import React from "react";
import {createFileRoute, useMatches, useParams} from "@tanstack/react-router";
import {GmailView} from "@src/pages/settings/integration-view";
import {useSingleIntegration} from "@zeg/instant/w/useIntegrations";
import {TIntegration, TProfile} from "@zeg/instant/types";
import {intConfig} from "@zeg/shared/intConfig";

export const Route = createFileRoute(
  "/_auth/_settings-layout/$workspaceSlug/settings/integrations/gmail"
)({component: RouteComponent});

function RouteComponent() {
  const accumulatedContext = useMatches({
    select: (matches) => matches[matches.length - 1].context,
  });
  const {workspaceSlug} = useParams({
    from: "/_auth/_settings-layout/$workspaceSlug/settings/integrations/gmail",
  });
  const gmailSlug = intConfig.gmail.slug;
  const activeProfile = accumulatedContext.auth.profiles.find(
    (profile: TProfile) => {
      const profileWorkspaceSlug = profile.$workspace?.slug;
      return profileWorkspaceSlug === workspaceSlug;
    }
  );
  const profileIdForHook = activeProfile?.id;
  const {data, isLoading, error} = useSingleIntegration(
    profileIdForHook as string,
    gmailSlug
  );

  let integrations: TIntegration[] = [];
  if (profileIdForHook && data) {
    if ("profiles" in data && data.profiles?.[0]) {
      integrations = data.profiles[0].integrations || [];
    } else if ("integrations" in data) {
      integrations = data.integrations || [];
    }
  }

  return (
    <GmailView
      integrations={integrations}
      isLoading={isLoading}
      error={error as Error}
      profile={activeProfile}
    />
  );
}
